import React from 'react';

import { Flex, Skeleton, Stack } from '@chakra-ui/react';

function OKRSidePanelSkeleton({ isLoaded }) {
  return (
    <Flex direction="column" height="100%" padding="20px" width="100%">
      <Flex padding="10px">
        <Stack width="100%">
          <Skeleton height="20px" width="100%" isLoaded={isLoaded} />
          <Skeleton height="20px" width="100%" isLoaded={isLoaded} />
          <Skeleton height="20px" width="100%" isLoaded={isLoaded} />
        </Stack>
      </Flex>
      <Flex direction="row">
        <Flex width="50px" padding="10px">
          <Stack width="100%" spacing="50px">
            <Skeleton height="40px" width="100%" isLoaded={isLoaded} />
            <Skeleton height="40px" width="100%" isLoaded={isLoaded} />
            <Skeleton height="40px" width="100%" isLoaded={isLoaded} />
            <Skeleton height="40px" width="100%" isLoaded={isLoaded} />
            <Skeleton height="40px" width="100%" isLoaded={isLoaded} />
            <Skeleton height="40px" width="100%" isLoaded={isLoaded} />
          </Stack>
        </Flex>

        <Flex grow="1">
          <Stack width="100%" padding="10px" spacing="30px">
            <Skeleton height="200px" width="100%" isLoaded={isLoaded} />
            <Skeleton height="200px" width="100%" isLoaded={isLoaded} />
            <Skeleton height="200px" width="100%" isLoaded={isLoaded} />
            <Skeleton height="200px" width="100%" isLoaded={isLoaded} />
            <Skeleton height="200px" width="100%" isLoaded={isLoaded} />
            <Skeleton height="200px" width="100%" isLoaded={isLoaded} />
          </Stack>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default OKRSidePanelSkeleton;
